/**
 * Surface container. Three built-in slots: header (title/tabs/search),
 * body/table, footer (counts + link).
 * Spec: assets/handoffs/design_system_export/specs/Card.json
 *
 * Usage: <Card aria-labelledby="members-card-title">
 *          <Card.Header id="members-card-title" title="Members" />
 *          <Card.Body>...</Card.Body>
 *          <Card.Footer>...</Card.Footer>
 *        </Card>
 *
 * @param {boolean=false} elevated - shadow-sm instead of shadow-xs, for panels over content
 */
import React from "react";
import classNames from "classnames";
import styles from "./Card.module.scss";

const Card = ({ elevated = false, className, children, ...rest }) => (
  <section className={classNames(styles.root, { [styles.elevated]: elevated }, className)} {...rest}>
    {children}
  </section>
);

const Header = ({ title, subtitle, id, className, children, ...rest }) => (
  <div className={classNames(styles.header, className)} {...rest}>
    {(title || subtitle) && (
      <div className={styles.headerText}>
        {title && (
          <h2 id={id} className={styles.title}>
            {title}
          </h2>
        )}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    )}
    {children}
  </div>
);

const Body = ({ noPadding = false, className, children, ...rest }) => (
  <div className={classNames(styles.body, { [styles.noPadding]: noPadding }, className)} {...rest}>
    {children}
  </div>
);

const Footer = ({ className, children, ...rest }) => (
  <div className={classNames(styles.footer, className)} {...rest}>
    {children}
  </div>
);

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
